import React, { useState } from 'react';
import { changeAdminPassword } from '../../api';

const ChangePasswordModal = ({ open, onClose }) => {
  const [form, setForm] = useState({ currentPassword: '', newPassword: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      const response = await changeAdminPassword(form.currentPassword, form.newPassword);
      setMessage(response.message || 'Password updated');
      setForm({ currentPassword: '', newPassword: '' });
    } catch (err) {
      setError(err.response?.data?.message || 'Unable to change password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/70 px-[1rem]">
      <form onSubmit={handleSubmit} className="w-full max-w-[520px] rounded-[18px] border border-[#262626] bg-[#111] p-[1.25rem]">
        <div className="flex items-center justify-between gap-[1rem]">
          <div>
            <p className="text-[12px] font-semibold uppercase tracking-[0.16em] text-[#EEC24B]">Settings</p>
            <h2 className="mt-[0.2rem] text-[24px] font-bold text-white">Change password</h2>
          </div>
          <button type="button" onClick={onClose} className="rounded-lg border border-[#262626] px-[0.85rem] py-[0.65rem] text-[14px] font-semibold">
            Close
          </button>
        </div>

        <div className="mt-[1rem] flex flex-col gap-[1rem]">
          <input
            type="password"
            value={form.currentPassword}
            onChange={(e) => setForm((prev) => ({ ...prev, currentPassword: e.target.value }))}
            placeholder="Current password"
            className="rounded-lg border border-[#262626] bg-[#1A1A1A] px-[0.95rem] py-[0.9rem] text-white outline-none"
          />
          <input
            type="password"
            value={form.newPassword}
            onChange={(e) => setForm((prev) => ({ ...prev, newPassword: e.target.value }))}
            placeholder="New password"
            className="rounded-lg border border-[#262626] bg-[#1A1A1A] px-[0.95rem] py-[0.9rem] text-white outline-none"
          />
        </div>

        {error && <p className="mt-[1rem] rounded-lg border border-red-900/40 bg-red-950/30 px-[1rem] py-[0.85rem] text-red-200">{error}</p>}
        {message && <p className="mt-[1rem] rounded-lg border border-emerald-900/40 bg-emerald-950/30 px-[1rem] py-[0.85rem] text-emerald-200">{message}</p>}

        <button
          type="submit"
          disabled={loading}
          className="mt-[1rem] rounded-lg bg-[#EEC24B] px-[1rem] py-[0.9rem] text-[15px] font-semibold text-black disabled:cursor-not-allowed disabled:opacity-60"
        >
          {loading ? 'Updating...' : 'Update password'}
        </button>
      </form>
    </div>
  );
};

export default ChangePasswordModal;
